import React from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import Container from 'components/Container';
import PaddedDivider from 'components/PaddedDivider';

const PodcastFooterContainer = styled(Container)`
  padding-bottom: 2em;
  text-align: center;
`;

const SubscribeButton = styled(Button)`
  margin: 16px 8px;
  img {
    height: 55px;
    width: auto;
    margin: -12px -24px;
  }
`;

const PodcastFooter = ({ subscribe_links }) => {
  return (
    <PodcastFooterContainer>
      <PaddedDivider />
      <Typography variant="h4" gutterBottom>
        Subscribe to CRISPR Cuts
      </Typography>

      {(subscribe_links || []).map((subscribe, idx) => (
        <SubscribeButton
          key={idx}
          variant="contained"
          size="large"
          color="secondary"
          href={subscribe.link.href}
          target="_blank"
          button
          component="a"
        >
          {subscribe.button_image?.url ? (
            <img
              src={subscribe.button_image?.url}
              alt={subscribe.link?.title || ''}
            />
          ) : (
            <>{subscribe.link?.title}</>
          )}
        </SubscribeButton>
      ))}
    </PodcastFooterContainer>
  );
};

export default PodcastFooter;
